import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Temporarily disabled Plausible analytics due to import error
// TODO: Fix Plausible analytics import
// import { initPlausible } from '@plausible-analytics/tracker';

// Initialize Plausible analytics
// Using proxy setup with domain hash: hN43gOh7lXFwBZL-uQVy0
// The domain will be automatically detected from window.location
// initPlausible({
//   domain: window.location.hostname,
//   apiHost: 'https://plausible.io',
//   // If using a proxy, you may need to configure it differently
//   // Check your Plausible dashboard for the exact domain name
// });

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Auth: simple password at /login only (sessionStorage gate)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
